

export default async function API(url: string, init?: RequestInit): Promise<any> {
    const resp = await fetch(url, init);
    const output = await resp.json();
    return new Promise((resolve, reject) => {
        if(output.success) resolve(output.response);
        else reject(output.error);
    })
}